module.exports = __webpack_public_path__ + "static/media/spinner.8ccdbe70.svg";